import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getContactSupport: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.contactSupport}`,
        method: "GET",
      }),
    }),

    getLegal: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.legal}`,
        method: "GET",
      }),
    }),

    getPrivacyPolicy: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.privacyPolicy}`,
        method: "GET",
      }),
    }),

    getFaq: builder.query<CommonResponse, { page: number; search: string }>({
      query: ({ page, search }) => ({
        url: `${END_POINTS.faq}?pageNumber=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    addLegal: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addLegal,
        method: "POST",
        body,
      }),
    }),

    addPrivacyPolicy: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addPrivacyPolicy,
        method: "POST",
        body,
      }),
    }),

    addContactSupport: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addContactSupport,
        method: "POST",
        body,
      }),
    }),

    addFaq: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addFaq,
        method: "POST",
        body,
      }),
    }),

    updateFaq: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.editFaq,
        method: "PATCH",
        body,
      }),
    }),

    deleteFaq: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFaq}/${id}`,
        method: "DELETE",
      }),
    }),

    addInterest: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addInterest,
        method: "POST",
        body,
      }),
    }),

    getInterest: builder.query<
      CommonResponse,
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.interest}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    deleteInterest: builder.query<CommonResponse, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteInterest}?Id=${id}`,
        method: "DELETE",
      }),
    }),

    getExpertise: builder.query<
      CommonResponse,
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.getExpertise}?pageNumber=${page}&search=${search}&pageSize=${100}`,
        method: "GET",
      }),
    }),

    addExpertise: builder.mutation<CommonResponse, { name: string }>({
      query: ({ name }) => ({
        url: `${END_POINTS.addExpertise}?name=${name}`,
        method: "POST",
      }),
    }),

    deleteExpertise: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteExpertise}?Id=${id}`,
        method: "DELETE",
      }),
    }),

    getDietary: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.getDietary}`,
        method: "GET",
      }),
    }),

    addAboutUs: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addAboutUs,
        method: "POST",
        body,
      }),
    }),

    getAboutUs: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.getAboutUs}`,
        method: "GET",
      }),
    }),

    addCancellation: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addCancellation,
        method: "POST",
        body,
      }),
    }),

    getCancellation: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.getCancellation}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetContactSupportQuery,
  useLazyGetLegalQuery,
  useLazyGetPrivacyPolicyQuery,
  useLazyGetFaqQuery,
  useAddLegalMutation,
  useAddContactSupportMutation,
  useAddPrivacyPolicyMutation,
  useAddFaqMutation,
  useUpdateFaqMutation,
  useLazyDeleteFaqQuery,
  useAddInterestMutation,
  useLazyGetInterestQuery,
  useLazyDeleteInterestQuery,
  useLazyGetExpertiseQuery,
  useAddExpertiseMutation,
  useLazyDeleteExpertiseQuery,
  useLazyGetDietaryQuery,
  useLazyGetAboutUsQuery,
  useLazyGetCancellationQuery,
  useAddAboutUsMutation,
  useAddCancellationMutation,
} = authApi;
